module.exports = __webpack_public_path__ + "img/Retirada de ramos podados do pomar.104d6ee5.webp";